const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,67.843137%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 0.683594 5.136719 L 2.726562 5.136719 L 2.726562 13 L 0.683594 13 C 0.304688 13 0 12.707031 0 12.34375 L 0 5.792969 C 0 5.429688 0.304688 5.136719 0.683594 5.136719 Z M 4.289062 4.289062 L 8.652344 0.0976562 C 8.773438 -0.0195312 8.964844 -0.03125 9.101562 0.0664062 L 9.683594 0.484375 C 10.011719 0.722656 10.160156 1.128906 10.058594 1.515625 L 9.273438 4.480469 L 13.636719 4.480469 C 14.390625 4.480469 15 5.070312 15 5.792969 L 15 7.171875 C 15 7.34375 14.964844 7.511719 14.898438 7.671875 L 12.789062 12.59375 C 12.683594 12.839844 12.433594 13 12.15625 13 L 4.773438 13 C 4.394531 13 4.089844 12.707031 4.089844 12.34375 L 4.089844 4.753906 C 4.089844 4.578125 4.164062 4.414062 4.289062 4.289062 Z M 4.289062 4.289062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.117c8a13efa71b81f3ed39ba1a3bf02b.svg";
export { ForwardRef as ReactComponent };